// extracted by mini-css-extract-plugin
export var alertIcon = "_no-0";